<template>
	<div class="alerts">
		<div>
			<alert v-for="(alert, index) in alerts" :key="index" :alert="alert" :index="index"></alert>
		</div>
	</div>
</template>
<script>
import {mapMutations, mapState} from "vuex";

export default {
	data() {
		return {};
	},

	computed: {
		...mapState("alertsStore", [
			"alerts",
		]),
	},

	methods: {
		...mapMutations("alertsStore", [
			"removeAlert",
		]),
	},
};
</script>
